<template>
  <div>
    <van-row>
      <van-col :span="24" @click="payMeth(1)" class="m-t-05">
        <van-image width="1rem" height="1rem" :src="wx" class="f-l-l" />
        <p class="f-s-16 f-l-l m-l-03">微信</p>
        <van-icon name="success" class="f-l-r" color="green" v-show="payFals == 1" />
      </van-col>
      <van-col :span="24" class="m-t-075" @click="payMeth(2)" v-if="jsFlag">
        <van-image width="1rem" height="1rem" :src="zfb" class="f-l-l" />
        <p class="f-s-16 f-l-l m-l-03">支付宝</p>
        <van-icon name="success" class="f-l-r" color="green" v-show="payFals == 2" />
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { getWxConfig, getOpenid } from "@/model/pay/payServer";
import { store, mutations } from "@/observable/store";
import { getAppClient } from "@/utils/commonUtils";

export default {
  data() {
    return {
      wx: require("@/assets/imgs/wx.png"),
      zfb: require("@/assets/imgs/zfb.png"),
      jsFlag: true,
      payFals:1,
    };
  },
  computed: {
    wxOpendId() {
      return store.openid;
    },
  },
  created() {
    let wxHerf = window.location.href;
    let code = wxHerf.split("?")[1] || wxHerf.split("?")[0] || "";
    if (code) {
      let codeArr = code.split("&");
      let codeParam = {};
      for (var i = 0; i < codeArr.length; i++) {
        codeParam[codeArr[i].split("=")[0]] = codeArr[i].split("=")[1];
      }
      if (codeParam.code) {
        let parmer = {
          appid: this.GLOBAL.wxPay.appid, //公众号appid
          code: codeParam.code, //code码
          towDomain: this.GLOBAL.formal
            ? "m.xzjy365.com"
            : "mceshi.xzjy365.com", //域名
        };
        getOpenid(parmer)
          .then((data) => {
            if (data && data.data.openid) {
              mutations.getOpenid(data.data.openid);
            }
          })
          .catch(() => {});
      } else {
        if (store.openid == "0" && getAppClient() == "JSAPI") {
          let url =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            this.GLOBAL.wxPay.appid +
            "&redirect_uri=" +
            encodeURIComponent(location.href) +
            "&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect";
          window.location.replace(url);
        }
      }
    }
    if (getAppClient() == "JSAPI") {
      this.jsFlag = false;
      let data = {
        url: encodeURIComponent(location.href.split("#")[0]),
        appId: this.GLOBAL.wxPay.appid,
      };
      getWxConfig(data).then((res) => {
        let data = res.data;
        if (data && data.timeStamp) {
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.GLOBAL.wxPay.appid, // 必填，公众号的唯一标识
            timestamp: data.timeStamp, // 必填，生成签名的时间戳
            nonceStr: data.nonce_str, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
              "checkJsApi",
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "hideMenuItems",
              "chooseImage",
              "uploadImage",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        }
      });
    }
  },
  methods:{
    payMeth(type){
      this.payFals = type
    }
  }
};
</script>

<style scoped>
</style>